export function rolesJson (language) {
  let items

  if (language === 'es') {
    items = {
      newRol: {
        name: 'newRol',
        label: 'crear un rol'
      },
      exportPdfRoles: {
        name: 'exportPdfRoles',
        label: 'exportar roles en formato pdf'
      },
      exportCsvRoles: {
        name: 'exportCsvRoles',
        label: 'exportar roles en formato csv'
      },
      removeRole: {
        name: 'removeRole',
        label: 'eliminar roles'
      },
      editRole: {
        name: 'editRole',
        label: 'editar roles'
      }
    }
  } else if (language === 'en') {
    items = {
      newRol: {
        name: 'newRol',
        label: 'create a role'
      },
      exportPdfRoles: {
        name: 'exportPdfRoles',
        label: 'export roles in PDF format'
      },
      exportCsvRoles: {
        name: 'exportCsvRoles',
        label: 'export roles in CSV format'
      },
      removeRole: {
        name: 'removeRole',
        label: 'delete roles'
      },
      editRole: {
        name: 'editRole',
        label: 'edit roles'
      }
    }
  }
  return (items)
}
